import React, { useState } from "react";
import SEO from "../components/shared/SEO";
import DashboardNavbar from "../components/shared/DashboardNavbar";
import DraftsHeader from "../components/dashboard/DraftsHeader";
import DraftsList from "../components/dashboard/DraftsList";

export default function Drafts() {
  const [count, setCount] = useState(3);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO
        title="Drafts | SoloConnect"
        description="Manage all your draft blog posts on SoloConnect."
        keywords="drafts, blog drafts, blog dashboard, SoloConnect"
      />
      <DashboardNavbar />

      <main className="flex-grow">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-8">
          <DraftsHeader count={count} />
          <DraftsList onCountChange={setCount} />
        </div>
      </main>
    </div>
  );
}
